import { BACKEND_URL } from "..";
import { TeamContext } from "../../types/common";
import { MatchInfo, MatchInfoShort, MatchLinks } from "../../types/fixtures";

export const getCalendar = async (tournamentUuid: string): Promise<MatchInfoShort[]> => {
    const response = await fetch(`${BACKEND_URL}/legacy/fixtures?tournamentUuid=${tournamentUuid}`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json'
        },
    });

    if (!response.ok) {
        console.error('Error');
        return Promise.reject(response.statusText);
    }

    const data = await response.json();

    return data.data;
}

export const getActual = async (team: TeamContext): Promise<MatchInfoShort[]> => {
    const response = await fetch(`${BACKEND_URL}/legacy/fixtures/actual?team=${team}`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json'
        },
    });

    if (!response.ok) {
        console.error('Error');
        return Promise.reject(response.statusText);
    }

    const data = await response.json();

    return data.data;
}

export const getFixtureById = async (id: number): Promise<MatchInfo> => {
    const response = await fetch(`${BACKEND_URL}/legacy/fixtures/fixture/${id}`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json'
        },
    });

    if (!response.ok) {
        console.error('Error');
        return Promise.reject(response.statusText);
    }

    const data = await response.json();

    return data;
}

export const getFixtureLinks = async (id: number): Promise<MatchLinks> => {
    const response = await fetch(`${BACKEND_URL}/legacy/fixtures/fixture/${id}/links`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json'
        },
    });

    if (!response.ok) {
        console.error('Error');
        return Promise.reject(response.statusText);
    }

    const data = await response.json();

    return data;
}